
import React, { useEffect, useState } from 'react';

const BackgroundPattern: React.FC = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  
  useEffect(() => {
    // Check if the image exists and preload it
    const img = new Image();
    img.src = '/lovable-uploads/00c921fe-bb3a-4eb5-ad50-76a967cd91c7.png'; // Using the logo image as background
    img.onload = () => setImageLoaded(true);
    img.onerror = () => {
      console.error('Background pattern image failed to load');
      setImageLoaded(false);
    };
  }, []);

  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden">
      {imageLoaded ? (
        <div 
          className="w-full h-full opacity-5"
          style={{ 
            backgroundImage: "url('/lovable-uploads/00c921fe-bb3a-4eb5-ad50-76a967cd91c7.png')",
            backgroundSize: "200px",
            backgroundRepeat: "repeat",
          }}
        ></div>
      ) : (
        // Fallback pattern if image doesn't load
        <div className="w-full h-full bg-repeat opacity-30">
          <div 
            className="w-full h-full bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 bg-repeat"
            style={{ 
              backgroundImage: `
                linear-gradient(to right, rgba(128, 90, 213, 0.1) 1px, transparent 1px),
                linear-gradient(to bottom, rgba(128, 90, 213, 0.1) 1px, transparent 1px)
              `,
              backgroundSize: "20px 20px" 
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default BackgroundPattern;
